/**
 * Builds the option list for an admin-user filter: an "unassigned" entry
 * followed by one option per person, labelled by full name.
 *
 * The four people filters (RAM, DSO RAM manager, DSO manager, …) all read a
 * differently-named slice of the same user shape, so only the list differs.
 */
export const peopleOptions = (people, unassignedLabel = 'Unassigned') => [
  { label: unassignedLabel, value: 'unassigned' },
  // An id-less record would become an empty option value: two of them collide
  // as duplicate React keys, and selecting one comma-joins to ",…".
  ...(people || [])
    .filter((person) => person?.id)
    .map((person) => ({
      label: [person.first_name, person.last_name].filter(Boolean).join(' '),
      value: person.id,
    })),
];

export default peopleOptions;
